import React from 'react';
import { DfCategoriesContext, initialValue } from './df-categories-context';
import { useQuery } from '@tanstack/react-query';
import { getCategories } from '../../api/categories';
import { ICategory } from '../../types';
import { getConfig } from '../../utils/config';

const pimLanguage = getConfig('pim_language', 'en');

export function DfCategoriesProvider({ children }: { children: React.ReactNode }) {
  const { data, isSuccess } = useQuery({
    queryKey: ['initial-categories-request'],
    queryFn: async () => {
      const response = await getCategories(pimLanguage);

      if (!response?.data?.categories) {
        return;
      }

      return {
        categories: response.data.categories,
        rootCategory:
          Object.values(response.data.categories).find((category: ICategory) => !category.pimPid)
            ?.pimId || -1,
      };
    },
    staleTime: Infinity,
    gcTime: Infinity,
    retry: false,
  });

  const providerValue = isSuccess ? data! : initialValue;

  return (
    <DfCategoriesContext.Provider value={providerValue}>{children}</DfCategoriesContext.Provider>
  );
}
